import 'popper.js/dist/esm/popper';
import { Modal, Tooltip, Alert } from 'bootstrap';
import loadImage from '../../../../node_modules/blueimp-load-image/js/index.js';
// import * as Sentry from "@sentry/browser";

import './components/axios.js';
import initJqueryAddons from './components/jquery-addons.js';
import initPrototypes from './components/prototypes.js';
import Cookie from '../../../dev/js/components/cookie.js';
import AuthService from './services/auth-service.js';
import ReCaptchaService from './services/recaptcha-service.js';
import ReCaptchaHandler from '../../../dev/js/components/recaptcha-handler.js';
import { TI_highlight_getSelection, TI_highlight_findLengthBefore } from './components/trustindex-review.js';
import DateRangePicker from '../../../dev/js/components/date-range-picker.js';
import TooltipHandler from '../../../dev/js/components/tooltip-handler.js';

initPrototypes();
initJqueryAddons();

window.$ = jQuery;
window.jQuery = jQuery;
window.Cookie = Cookie;
window.BS_VERSION = parseFloat(Tooltip.VERSION);
// window.auth_hash_checked = null;
// window.auth = auth;
window.authService = new AuthService();
window.reCaptchaService = new ReCaptchaService();
window.loadImage = loadImage;
window.TI_highlight_getSelection = TI_highlight_getSelection;
window.TI_highlight_findLengthBefore = TI_highlight_findLengthBefore;
window._AutofillCallbackHandler = window._AutofillCallbackHandler || function(){} // Sentry fix for is ios Safari autofill

$(function () {

	// if (window.ssr === true) {
	// 	Sentry.init({
	// 		dsn: "https://b5aa15af255ae72d10f6565d13b950f1@o4506948417617920.ingest.us.sentry.io/4506982244352000",
	// 		integrations: [
	// 			Sentry.replayIntegration(),
	// 		],
	// 		// Session Replay
	// 		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	// 		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	// 	});
	// }

	// Init tooltip and collapse functions
	TooltipHandler.init();

	// Init date range picker functions
	DateRangePicker.init();

	// Init date range picker functions
	window.reCaptchaService.init();
	ReCaptchaHandler.init();

	// Init handler which check the login card buttons
	window.authService.init();
});